import axios from 'axios'
import { API } from '../constants/system'
import { getLoginApp, getchek, getDominio } from '../utils/functions';
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'
axios.defaults.withXSRFToken = true;
//import { tokenCopyPaste } from '../utils/functions'
//local
/* 
http://Ari_Pos6.5/public/pos 
appsc.aritech.top
*/

export function postRequest_(data, view) {

  let dominio = window.localStorage.getItem('ari_app_dominio').split('http');
  let url = "";
  if (dominio.length > 1) {
    url = window.localStorage.getItem('ari_app_dominio');
  } else {
    url = "https://" + window.localStorage.getItem('ari_app_dominio');
  } 


  return axios.post(`${url}/${view}`, data, { headers: { Authorization: 'Bearer ' + window.localStorage.getItem('ari_app_token') } });
}

export function getRequest(data, view) {
 
  let dominio = window.localStorage.getItem('ari_app_dominio').split('http');
  let url = "";
  if (dominio.length > 1) {
    url = window.localStorage.getItem('ari_app_dominio');
  } else {
    url = "https://" + window.localStorage.getItem('ari_app_dominio');
  } 

  return axios.get(`${url}/${view}`, { params: data, headers: { Authorization: 'Bearer ' + window.localStorage.getItem('ari_app_token') } });
}
